import axios from 'axios';
import {Toast} from 'vant';
import {getRequestParams, isEmpty, randomLenStr, containUrl} from './index';
import * as crypto from './crypto';

const cryptoMode = true;

// 系统全局请求对象
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 10000,
  responseType: 'json'
});

service.interceptors.request.use(
  config => {
    if (cryptoMode) {
      const aesKey = randomLenStr(16);
      const key = crypto.encryptRSA(aesKey);
      let timestamp = new Date().getTime();
      let hasBody = false;
      // 对body加密
      if (!isEmpty(config.data)) {
        hasBody = true;
        let body = {...config.data};
        body.nonce = crypto.initNonce(timestamp);
        body.timestamp = timestamp;
        let stringA = crypto.initSort(body);
        body.sign = crypto.initSign(stringA, aesKey);
        config.data = {
          data: crypto.encryptAES(JSON.stringify(body), aesKey),
          key
        };
      }
      // 对param加密
      let paramsJson = getRequestParams(config.url);
      if (paramsJson) {
        config.params = Object.assign({}, config.params, paramsJson);
        config.url = config.url.substring(0, config.url.indexOf('?'));
      }
      if (!isEmpty(config.params) || !hasBody) {
        let params = Object.assign({}, config.params);
        params.nonce = crypto.initNonce(timestamp);
        params.timestamp = timestamp;
        let stringA = crypto.initSort(params);
        params.sign = crypto.initSign(stringA, aesKey);
        config.params = {
          data: crypto.encryptAES(JSON.stringify(params), aesKey),
          key
        };
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截响应
service.interceptors.response.use(
  response => {
    if (cryptoMode && response.data) {
      try {
        let result = response.data.result;
        let rsaKey = response.data.key;
        if (result && rsaKey) {
          let key = crypto.decryptRSA(rsaKey);
          let decryptData = crypto.decryptAES(result, key);
          response.data = JSON.parse(decryptData);
        }
      } catch (e) {
        console.log(e.message);
      }
    }
    return response.data;
  },
  (error) => {
    if (error.response) {
      let errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message;
      switch (error.response.status) {
        case 404:
          Toast.fail('很抱歉，资源未找到');
          break;
        case 403:
        case 401:
          Toast.fail('很抱歉，您无法访问该资源');
          break;
        default:
          Toast.fail(errorMessage);
          break;
      }
    }
    return Promise.reject(error);
  });

const request = {
  get(url, params) {
    let _params = '';
    if (!Object.is(params, undefined)) {
      _params = '?';
      for (const key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return service.get(`${url}${_params}`);
  },
  post(url, params) {
    return service.post(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params);
      }],
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },
  put(url, params) {
    return service.put(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params);
      }],
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },
  delete(url, params) {
    let _params = '';
    if (!Object.is(params, undefined)) {
      _params = '?';
      for (const key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`;
        }
      }
    }
    return service.delete(`${url}${_params}`);
  },
  upload(url, params) {
    return service.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

function tansParams(params) {
  let result = '';
  Object.keys(params).forEach((key) => {
    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
      result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
    }
  });
  return result;
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js